<template>
  <div>
    <div>
      <div class="row row-header ml-4">
        <div class="col-2 col-header text-danger">
          Receipt Date
        </div>
        <div class="col-3 col-header text-danger">
          Reimburse
        </div>
        <div class="col-3 col-header text-danger">
          Title
        </div>
        <div class="col-2 col-header text-danger">
          Paid To
        </div>
        <div class="col-2 col-header text-danger text-right">
          Amount
        </div>
      </div>
      <div class="row row-header ml-4">
        <div class="col-3 col-header text-danger">
          Budget Item
        </div>
        <div class="col-9 col-header text-danger">
          Memo
        </div>
      </div>
    </div>
    <div
      class="row-data"
      v-for="detail in reimbursementDetails"
      :key="detail.Id"
    >
      <div class="row ml-4">
        <div class="col-2">
          {{ dateFormatter(detail.ReceiptDate) }}
        </div>
        <div class="col-3">
          {{ detail.Payee }}
        </div>
        <div class="col-3">
          {{ detail.Title }}
        </div>
        <div class="col-2">
          {{ detail.PayerName }}
        </div>
        <div class="col-2 text-right">
          {{ currencyFormatter(detail.Amount) }}
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          {{ detail.BudgetItemName }}
        </div>
        <div class="col-9">
          {{ detail.Memo }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatter from '@/services/formatter.js'

export default {
  name: 'ReportReimbursementDetails',
  props: {
    reimbursementDetails: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    dateFormatter: function (cellValue) {
      return formatter.formatAsDateTime(cellValue)
    },
    currencyFormatter: function (cellValue) {
      return formatter.formatAsCurrency(cellValue, 2)
    }
  }
}
</script>
